import {ACTIVITY_LIST, ACTIVITY_DETAILS} from 'App/store/constants';
const initialState = {
  activityListData: null,
  activityDetailData: null,
  errors: null,
  loading: false,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ACTIVITY_LIST.PENDING:
      return {...state, errors: null, activityListData: null, loading: true};
    case ACTIVITY_LIST.SUCCESS:
      return {...state, activityListData: action.payload.data.data, loading: false};
    case ACTIVITY_LIST.FAILURE:
      return {...state, errors: action.payload, loading: false};

    case ACTIVITY_DETAILS.PENDING:
      // Do NOT clear activityDetailData on PENDING — clearing it here causes the
      // component to unmount/remount the detail view on every fetch, producing
      // a visible flicker and triggering repeated re-renders.
      // The previous detail stays visible until SUCCESS replaces it.
      return {
        ...state,
        errors: null,
        loading: true,
      };
    case ACTIVITY_DETAILS.SUCCESS:
      return {
        ...state,
        activityDetailData: action.payload.data.data,
        loading: false,
      };
    case ACTIVITY_DETAILS.FAILURE:
      return {...state, errors: action.payload, loading: false};
    default:
      return state;
  }
};

export default reducer;
